import { forwardRef, type Ref, type SVGProps } from "react";
function SvgStopWatchWarning(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={69}
      fill="none"
      {...props}
    >
      <g clipPath="url(#stop-watch-warning_svg__a)">
        <circle
          cx={49.409}
          cy={34.5}
          r={28.409}
          stroke="url(#stop-watch-warning_svg__b)"
          strokeWidth={10}
        />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.947}
          d="m49.349 34.47-2.927-2.84m.732-7.339h4.39m5.854 10.18c0 4.315-3.604 7.812-8.049 7.812s-8.05-3.497-8.05-7.812 3.605-7.813 8.05-7.813 8.05 3.498 8.05 7.813"
        />
      </g>
      <defs>
        <linearGradient
          id="stop-watch-warning_svg__b"
          x1={49.409}
          x2={49.409}
          y1={6.091}
          y2={62.909}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FFE3C3" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="stop-watch-warning_svg__a">
          <rect width={56.818} height={56.818} x={21} y={6.091} fill="#fff" rx={28.409} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgStopWatchWarning);
export default ForwardRef;
